import { Injectable } from '@angular/core';
import { NEVER, Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ElementHistoryDocument } from 'src/app/models/domain';
import { SharePointService } from 'src/app/services';
import { handleError } from './akita-error-helper';
import { CollectionState } from './collection-state';

@Injectable({ providedIn: 'root' })
export class ElementHistoryDocumentService {
  private readonly state = new CollectionState<ElementHistoryDocument>();

  public readonly elementHistoryDocuments$ = this.state.items$;
  public readonly loading$ = this.state.loading$;
  public readonly error$ = this.state.error$;

  public constructor(private readonly sharePointService: SharePointService) {}

  public loadByDesignId(designId: string): Observable<void> {
    this.state.setLoading(true);

    return this.sharePointService.getElementHistoryDocumentsForDesignId(designId).pipe(
      tap((elementHistoryDocuments) => {
        this.state.set(elementHistoryDocuments);
      }),
      catchError((error) => {
        handleError(this.state, error);

        return NEVER;
      }),
      map(() => undefined)
    );
  }

  public reset() {
    this.state.reset();
  }
}
